<template>
    <div class="addWx">
        <el-dialog title="绑定微信号" width="30%" :visible.sync="visible" @close="clearFun">
            <div class="bind-box">
                <p class="yx-color-text-primary mb-10">请用您的微信号扫描以下二维码进行授权并绑定</p>
                <img :src="qr_link" alt="">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { checkBind } from '@/api/personal';
export default {
    name: 'addWx',
    components: {
        
    },
    data() {
        return {
            visible: false,
            qr_link: '',
            bind_status: true,
            polling: false,
            timer: null,
        }
    },
    watch: {
        "polling": {
            handler(to, from) {
                if(!this.bind_status) {
                    this.timer && clearInterval(this.timer)
                    this.timer = setInterval(() => {
                        this.checkFun()
                    }, 2000)
                }else {
                    this.$message.success('绑定成功')
                    clearInterval(this.timer)
                    this.visible = false
                    this.$emit('Refresh')
                }
            },
        }
    },
    beforeDestroy() {
        this.$once('hook:beforeDestroy', () => {            
            clearInterval(this.timer)                                 
        })
    },
    methods: {
        show(value, total) {
            this.polling = false
            this.total = total
            this.qr_link = value
            this.visible = true
            this.checkFun()
        },
        async checkFun() {
            const {code,data} = await checkBind({bind_num: this.total})
            if(code === 0) {
                this.bind_status = data.bind_status
                if(this.bind_status) {
                    this.polling = false
                }else {
                    this.polling = true
                }
            }
        },
        clearFun() {
            clearInterval(this.timer)
            this.timer = null
        }
    }
}
</script>
<style lang="less" scoped>
.bind-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
        width: 200px;
        height: 200px;
    }
}
</style>